import { useMemo } from 'react'
import { InvoicesSummaryRequestParams } from '@/hooks'
import { useDashboardUsageAndCostFiltersStore } from './useDashboardUsageAndCostFiltersStore'
import { useAnalyticsFiltersGetParams } from '@/features/Analytics/hooks/useAnalyticsFiltersGetParams'

export const useDashboardFiltersGetParams =
    (): InvoicesSummaryRequestParams => {
        const activeFilters = useDashboardUsageAndCostFiltersStore(
            (state) => state.activeFilters
        )
        const filterParams = useAnalyticsFiltersGetParams(activeFilters)

        return useMemo(
            () => ({
                'nodeIds[]': filterParams['nodeIds[]'],
                commodityTypeId: filterParams.commodityTypeId,
                unitOfMeasureId: filterParams.unitOfMeasureId,
            }),
            [filterParams]
        )
    }
